import styled from "styled-components";
import { Link } from "react-router-dom";

export default function Ferramentas(){

    const tools = [
        {
            title: "Calculadora de Combustível",
            desc: "Descubra qual combustível compensa mais com base no preço e rendimento do seu carro.",
            link: "/ficha-tecnica"
        },
        {
            title: "Calculadora de custo de viagem",
            desc: "Calcule o gasto total de uma viagem considerando distância, consumo e combustível.",
            link: "/comparacao"
        },
        {
            title: "Comparador de combustível",
            desc: "Compare gasolina, etanol e diesel de forma rápida e inteligente.",
            link: "/tabela-fipe"
        },
        {
            title: "Tabela de manutenção",
            desc: "Veja os custos médios de manutenção dos principais veículos do mercado.",
            link: "/mais-vendidos"
        },
        {
            title: "Simulador de financiamento",
            desc: "Simule parcelas, juros e tempo de financiamento de veículos.",
            link: "/opiniao"
        },
        {
            title: "Calculadora de custo do carro",
            desc: "Descubra quanto realmente custa manter um carro por mês.",
            link: "/opiniao"
        },
        {
            title: "Recomendador de carros",
            desc: "Receba sugestões de veículos com base no seu perfil e orçamento.",
            link: "/opiniao"
        }
    ];

    return (
        <Container>
            <Header>
                <h1>Ferramentas</h1>
                <p>Utilize nossas ferramentas para tomar decisões mais inteligentes no mundo automotivo</p>
            </Header>

            <Grid>
                {tools.map((tool, index) => (
                    <Card key={index}>
                        <h3>{tool.title}</h3>
                        <p>{tool.desc}</p>
                        <StyledLink to={tool.link}>Acessar</StyledLink>
                    </Card>
                ))}
            </Grid>
        </Container>
    );
}

/* CONTAINER */
const Container = styled.div`
    padding: 60px 40px;
    background-color: #111;
    color: #fff;
    min-height: 100vh;
`;

/* HEADER */
const Header = styled.div`
    text-align: center;
    margin-bottom: 50px;

    h1{
        font-size: 40px;
        color: #ff1a1a;
        margin-bottom: 10px;
    }

    p{
        font-size: 16px;
        opacity: 0.8;
    }
`;

/* GRID */
const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 25px;
`;

/* CARD */
const Card = styled.div`
    background: #1a1a1a;
    padding: 25px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: 0.3s;
    border: 1px solid transparent;

    &:hover{
        transform: translateY(-5px);
        border-color: #ff1a1a;
    }

    h3{
        margin-bottom: 10px;
        color: #fff;
    }

    p{
        font-size: 14px;
        opacity: 0.8;
        margin-bottom: 20px;
    }
`;

/* BOTÃO */
const StyledLink = styled(Link)`
    text-align: center;
    padding: 10px;
    border-radius: 6px;
    text-decoration: none;
    font-weight: bold;
    background: linear-gradient(90deg, #b30000, #ff1a1a);
    color: white;
    transition: 0.3s;

    &:hover{
        opacity: 0.8;
    }
`;